<template>
  <el-card v-loading="loading">
    <div ref="scrollContainer" id="page-panel" >
      <!-- <resize-observer @notify="__resizeHanlder" /> -->

        <div class="customer-top-nav">
          <div class="title">
            <span>{{$t('reports.names.'+reportCode)}}</span><br>
          </div>
          <div class="controls no-print">
             <!-- <el-button @click="print" size="small"><i class="mdi mdi-printer"></i> Télécharger</el-button> -->
             <el-dropdown size="small" type="default" class="">
               <el-button type="primary" size="small">
                 <i class="el-icon-download"></i>
               </el-button>
               <el-dropdown-menu slot="dropdown">
                 <el-dropdown-item @click.native="downloadReport('pdf')"><i class="mdi mdi-file-pdf"/> PDF</el-dropdown-item>
               </el-dropdown-menu>
             </el-dropdown>
    				 
    			</div>
        </div>

        <div>
          <el-form :model="filters" label-width="120px">
            <el-form-item label="Représentant">
              <el-select v-model="filters.repId" size="small" placeholder="Représentant">
                <el-option v-for="rep in filterUserWithRoleRep" :key="rep.id" :label="rep.firstName + ' ' + rep.lastName" :value="rep.id"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="Mois">
                  <el-date-picker
                    v-model="filters.date"
                    type="month"
                    :picker-options="datePickerOptions"
                    placeholder="Sélectionnez un mois">
                  </el-date-picker>
            </el-form-item>
            <el-button :disabled="!searchPossible" type="primary" size="small" @click="fetchData">Afficher</el-button>
          </el-form>
        <el-divider/>
        <el-pagination
          :small="pagination.small"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.sizes"
          :page-size.sync="pagination.size"
          :layout="pagination.layout"
          :total="totalRecords"
          :hide-on-single-page="true"
        ></el-pagination>
        <el-table :data="listInPage" :style="tableWidth" stripe empty-text="Il n'y a aucune transaction adminissible pour cette période.">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column   label="Facture" prop="invoiceNumber" sortable>
            <template slot-scope="scope">
              <span class="fs-12">{{_moment(scope.row.date)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="Date paiement" prop="date" sortable>
            <template slot-scope="scope">
              <span class="fs-12">{{_moment(scope.row.date)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="Produit" prop="product.name" sortable :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <!-- <el-link :underline="false" @click="openCustomer(scope.row.customer.id)" type="primary"><span class="fs-12">{{(scope.row.customer.name)}}</span></el-link><el-link :href="'/customers/'+scope.row.customer.id" target="_blank" type="primary" :underline="false"><i class="mdi mdi-launch ml-10"></i></el-link> -->
            </template>
          </el-table-column>
          <el-table-column label="Frais" prop="type.code" sortable :show-overflow-tooltip="true" width="120">
            <template slot-scope="scope">
              <span class="fs-12">{{$t('invoices.'+scope.row.type.code)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="% Comm." :show-overflow-tooltip="true">
            <template slot-scope="scope">
              
            </template>
          </el-table-column>
           <el-table-column   label="Total" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              
            </template>
          </el-table-column>
          <el-table-column   label="">
            <template slot-scope="scope">
              
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :small="pagination.small"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.sizes"
          :page-size.sync="pagination.size"
          :layout="pagination.layout"
          :total="totalRecords"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
  </el-card>
</template>
<script>
//import Section
import commissionsAPI from '@/services/API/commission.js'

import moment from 'moment'
import dayjs from 'dayjs'
import reportUtil from '@/utils/report-util.js'
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import { mapActions, mapState, mapGetters } from 'vuex';


export default {
  name : "report-commission",
  props : {
    width : {
      type : Number,
      default : 100
    },

  },
  data() {
    return {
      data : [],
      loading: false,
      datePickerOptions: {
          disabledDate :this.disabledDateBeforeDate
      },
      filters : {
        repId : null,
        date : null,
      },
      months: [
        {
          id: 1,
          label: 'Janvier'
        },
        {
          id: 2,
          label: 'Février'
        },
        {
          id: 3,
          label: 'Mars'
        },
        {
          id: 4,
          label: 'Avril'
        },
        {
          id: 5,
          label: 'Mai'
        },
        {
          id: 6,
          label: 'Juin'
        },
        {
          id: 7,
          label: 'Juillet'
        },
        {
          id: 8,
          label: 'Août'
        },
        {
          id: 9,
          label: 'Septembre'
        },
        {
          id: 10,
          label: 'Octobre'
        },
        {
          id: 11,
          label: 'Novembre'
        },
        {
          id: 12,
          label: 'Décembre'
        }
      ],
      pageWidth : null,
      pageHeight : null,
      pagination: {
        page: 1,
        size: 20,
        sizes: [10, 15, 20, 30, 50, 100],
        layout: 'total, ->, prev, pager, next, sizes',
        small: false
      },
    };
  },
  components : {
    PortausLink
  },
  computed : {
    reportCode(){
      return this.$route.params.code;
    },
    searchPossible() {
      return this.filters.repId != null && this.filters.date != null;
    },
    usableData(){
      return this.data;
    },
    totalRecords() {
			return this.usableData.length
		},
    listInPage(){
      let from = (this.currentPage - 1) * this.itemPerPage
      let to = from + (this.itemPerPage*1)
      //return this.listSortered.slice(from, to)
      return this.usableData.slice(from, to)
    },
    currentPage: {
			get() {
				return this.pagination.page
			},
			set(val) {
				this.pagination.page = val
			}
		},
    itemPerPage() {
			return this.pagination.size
		},
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },

    ...mapState('controlData',['paymentTypeCategories']),
    ...mapGetters('users',['filterUserWithRoleRep', 'getUserById']),
  },
  methods : {
    disabledDateBeforeDate (date) {
      console.log(date);
        return  date < new Date('2025-09-01');
    },
    downloadReport(format){
      // this.downloading=true;
      // let filters = _.cloneDeep(this.filters);
      // if(filters.startDate!=null){
      //   filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      // }
      // if(filters.endDate!=null){
      //   filters.endDate = moment(filters.endDate).add(1, 'days').format('YYYY-MM-DD Z');
      // }
      // // console.log(filters);
      // if(filters.customerId!=null){
      //   filters.customerName = localStorage.payments_customerName;
      // }


      // filters.format=format

      // let filename = 'PAYMENTS_REPORT_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');
      // filename+="."+format;

      // if (format === 'QUICKBOOKS') {
      //   return paymentAPI.downloadQuickbooksExtractPaymentsCSV(filters, filename)
      //   .then(()=>{
      //     this.downloading=false;
      //   }).catch(err=>{
      //     this.downloading=false;
      //     this.$message.error("Oops... Une erreur est survenue!");
      //   })
      // }

      // return salesAPI.downloadSalesReport(this.reportCode, filename, filters);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    handleFilter(filters){
      // localStorage.payments_groupBy=filters.group;
      // localStorage.payments_range=filters.period.code;
      // localStorage.payments_startDate = filters.dateRange[0];
      // localStorage.payments_endDate = filters.dateRange[1];
      // localStorage.payments_customerId = filters.customer!=null ? filters.customer.id : undefined;
      // if(filters.customer!=null){
      //   localStorage.payments_customerName = CustomerUtil.customerName(filters.customer.name,filters.customer.usual_name);
      // }
      // let methods = [];
      // _.forEach(filters.paymentMethods, m=>{
      //   methods.push(m.id);
      // })
      // localStorage.payments_methods = JSON.stringify(methods);
      // this.setFilters();
      // this.fetchData();
    },

		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    fetchData(format = null){
      this.loading = true;
      const filters = {
        repId: this.filters.repId,
        startDate: this.filters.date ? dayjs(this.filters.date).startOf('month').format('YYYY-MM-DD Z') : null,
        endDate: this.filters.date ? dayjs(this.filters.date).endOf('month').add(1, 'day').format('YYYY-MM-DD Z') : null,
      }
    
      return commissionsAPI.fetchCommissions(filters)
        .then(data=>{
          this.data = data;
          this.loading = false;
        }).catch(err=>{
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){
      
    },
    ...mapActions('controlData',['fetchPaymentTypeCategories']),
     ...mapActions('users', ['fetchAdminUsers']),
  },
  mounted(){
    this.fetchAdminUsers();
    this.setPageWidth();
  },
  created(){
    this.filters.date = dayjs().subtract(1, 'month').startOf('month').toDate()
  },
  beforeDestroy(){
    this.data = [];
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}



.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
